import {useQuery} from 'react-query';
import {campaignService} from 'src/shared/services/campaigns';
import MainUtils from 'src/shared/utils/main';

export const useGetCampaign = (id: string) => {
  return useQuery(['campaign', id], () => campaignService.getCampaign(id), {
    enabled: !MainUtils.isEmptyValue(id),
  });
};
